"use strict";
/* eslint-disable no-irregular-whitespace */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splashScreen = exports.breakpointsValues = exports.Button = exports.IconButton = exports.Icon = exports.Text = exports.makeStyles = exports.useTheme = void 0;
var compat_1 = require("tss-react/compat");
var Icon_1 = require("onyxia-ui/Icon");
var IconButton_1 = require("onyxia-ui/IconButton");
var Button_1 = require("onyxia-ui/Button");
var Brightness4_1 = __importDefault(require("@mui/icons-material/Brightness4"));
var Brightness7_1 = __importDefault(require("@mui/icons-material/Brightness7"));
var ArrowBackIos_1 = __importDefault(require("@mui/icons-material/ArrowBackIos"));
var ArrowForwardIos_1 = __importDefault(require("@mui/icons-material/ArrowForwardIos"));
var Dehaze_1 = __importDefault(require("@mui/icons-material/Dehaze"));
var Brightness1Rounded_1 = __importDefault(require("@mui/icons-material/Brightness1Rounded"));
var Text_1 = require("onyxia-ui/Text");
var onyxia_ui_1 = require("onyxia-ui");
var ThemeProvider_1 = require("onyxia-ui/lib/ThemeProvider");
function useTheme() {
    var theme = (0, ThemeProvider_1.useStyles)().theme;
    return __assign(__assign({}, theme), { "paddingRightLeft": theme.spacing((function () {
            if (theme.windowInnerWidth >= exports.breakpointsValues["lg"]) {
                return 7;
            }
            if (theme.windowInnerWidth >= exports.breakpointsValues["sm"]) {
                return 6;
            }
            return 4;
        })()), "customShadow": "2px 3px 35px -1px rgba(0,0,0,0.45);" });
}
exports.useTheme = useTheme;
exports.makeStyles = (0, compat_1.createMakeStyles)({ useTheme: useTheme }).makeStyles;
exports.Text = (0, Text_1.createText)({ useTheme: useTheme }).Text;
exports.Icon = (0, Icon_1.createIcon)({
    "brightness4": Brightness4_1.default,
    "brightness7": Brightness7_1.default,
    "arrowBackIos": ArrowBackIos_1.default,
    "arrowForwardIos": ArrowForwardIos_1.default,
    "dehaze": Dehaze_1.default,
    "brightness1Rounded": Brightness1Rounded_1.default,
}).Icon;
exports.IconButton = (0, IconButton_1.createIconButton)({ Icon: exports.Icon }).IconButton;
exports.Button = (0, Button_1.createButton)({ Icon: exports.Icon }).Button;
exports.breakpointsValues = __assign(__assign({}, onyxia_ui_1.breakpointsValues), { "lg+": 1440 });
exports.splashScreen = {
    "Logo": function () { return null; },
    "minimumDisplayDuration": 0,
};
//# sourceMappingURL=theme.js.map